"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Panel = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var classnames_1 = require("../util/classnames");
var collapse_1 = require("./collapse");
var pagination_next_1 = __importDefault(require("adp-react-icons/lib/adp/pagination-next"));
var vdl_prefix_1 = require("../util/vdl-prefix");
var _1 = require("../util/_");
var Panel = /** @class */function (_super) {
  __extends(Panel, _super);
  function Panel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.state = {
      expanded: _this.props.defaultExpanded || _this.props.expanded || false
    };
    _this.handleSelect = function (event) {
      event.persist();
      event['selected'] = true;
      var _a = _this.props,
        onSelect = _a.onSelect,
        eventKey = _a.eventKey;
      if (onSelect) {
        onSelect(eventKey, event, !_this.state.expanded);
      } else {
        event.preventDefault();
      }
      if (event['selected']) {
        _this.handleToggle();
      }
    };
    _this.handleToggle = function () {
      _this.setState({
        expanded: !_this.state.expanded
      });
    };
    _this.isExpanded = function () {
      return _this.state.expanded;
    };
    _this.renderCollapsibleBody = function (panelRole) {
      var collapseProps = {
        onEnter: _this.props.onEnter,
        onEntering: _this.props.onEntering,
        onEntered: _this.props.onEntered,
        onExit: _this.props.onExit,
        onExiting: _this.props.onExiting,
        onExited: _this.props.onExited,
        in: _this.isExpanded(),
        className: vdl_prefix_1.vdlPrefix('accordion-collapse'),
        enteringClassName: vdl_prefix_1.vdlPrefix('accordion-collapse--entering'),
        enteredClassName: vdl_prefix_1.vdlPrefix('accordion-collapse--entered'),
        exitingClassName: vdl_prefix_1.vdlPrefix('accordion-collapse--exiting'),
        exitedClassName: vdl_prefix_1.vdlPrefix('accordion-collapse--exited')
      };
      var props = {
        id: _this.props.id,
        ref: 'panel',
        'aria-hidden': !_this.isExpanded(),
        role: panelRole ? panelRole : undefined
      };
      return react_1.default.createElement(collapse_1.Collapse, __assign({}, collapseProps), react_1.default.createElement("div", __assign({}, props), _this.renderBody()));
    };
    _this.renderBody = function () {
      var allChildren = _this.props.children;
      var bodyElements = [];
      var panelBodyChildren = [];
      var bodyClass = vdl_prefix_1.vdlPrefix('accordion-panel__body');
      function getProps() {
        return {
          key: bodyElements.length
        };
      }
      function addPanelChild(child) {
        bodyElements.push(react_1.default.cloneElement(child, getProps()));
      }
      function addPanelBody(children) {
        bodyElements.push(react_1.default.createElement("div", __assign({
          className: bodyClass
        }, getProps()), children));
      }
      function maybeRenderPanelBody() {
        if (panelBodyChildren.length === 0) {
          return;
        }
        addPanelBody(panelBodyChildren);
        panelBodyChildren = [];
      }
      // Handle edge cases where we should not iterate through children.
      if (!Array.isArray(allChildren) || allChildren.length === 0) {
        if (_this.shouldRenderFill(allChildren)) {
          addPanelChild(allChildren);
        } else {
          addPanelBody(allChildren);
        }
      } else {
        allChildren.forEach(function (child) {
          if (_this.shouldRenderFill(child)) {
            maybeRenderPanelBody();
            // Separately add the filled element.
            addPanelChild(child);
          } else {
            panelBodyChildren.push(child);
          }
        });
        maybeRenderPanelBody();
      }
      return bodyElements;
    };
    _this.renderHeading = function (headerRole) {
      var header = _this.props.header;
      if (!header) {
        return null;
      }
      if (!react_1.default.isValidElement(header) || Array.isArray(header)) {
        header = _this.props.collapsible ? _this.renderCollapsibleTitle(header, headerRole) : header;
      } else {
        var headerProps = header.props;
        var headerClassName = headerProps['className'];
        var className = classnames_1.classNames(vdl_prefix_1.vdlPrefix('accordion-panel__title'), headerClassName);
        if (_this.props.collapsible) {
          header = _this.renderAnchor(header, headerRole, className);
        } else {
          header = react_1.default.cloneElement(header, {
            className: className
          });
        }
      }
      return react_1.default.createElement("div", {
        className: vdl_prefix_1.vdlPrefix('accordion-panel__heading')
      }, header);
    };
    _this.renderIcon = function () {
      return react_1.default.createElement(pagination_next_1.default, {
        className: _this.isExpanded() ? vdl_prefix_1.vdlPrefix('accordion-panel__icon toggle') : vdl_prefix_1.vdlPrefix('accordion-panel__icon')
      });
    };
    _this.renderAnchor = function (header, headerRole, className) {
      return react_1.default.createElement("div", {
        className: className
      }, react_1.default.createElement("a", {
        href: '#' + (_this.props.id || ''),
        "aria-controls": _this.props.collapsible ? _this.props.id : '',
        "aria-expanded": _this.isExpanded(),
        "aria-selected": _this.isExpanded(),
        onClick: _this.handleSelect,
        role: headerRole
      }, _this.renderIcon(), header));
    };
    _this.renderCollapsibleTitle = function (header, headerRole) {
      return react_1.default.createElement("div", {
        className: vdl_prefix_1.vdlPrefix('accordion-panel__title'),
        role: "presentation"
      }, _this.renderAnchor(header, headerRole));
    };
    _this.renderFooter = function () {
      if (!_this.props.footer) {
        return null;
      }
      return react_1.default.createElement("div", {
        className: vdl_prefix_1.vdlPrefix('accordion-panel__footer')
      }, _this.props.footer);
    };
    return _this;
  }
  Panel.prototype.componentWillReceiveProps = function (newProps) {
    if (newProps && (newProps.expanded === true || newProps.expanded === false) && newProps.expanded != this.state.expanded) {
      this.setState({
        expanded: newProps.expanded
      });
    }
  };
  Panel.prototype.shouldRenderFill = function (child) {
    return react_1.default.isValidElement(child) ? child.props['fill'] != null : false;
  };
  Panel.prototype.render = function () {
    var _a;
    var _b = this.props,
      headerRole = _b.headerRole,
      panelRole = _b.panelRole;
    var customProps = _1.omit(this.props, Object.keys(Panel.propTypes));
    var panelClasses = (_a = {}, _a[vdl_prefix_1.vdlPrefix('accordion-panel')] = true, _a[vdl_prefix_1.vdlPrefix('accordion-panel--expanded')] = this.isExpanded(), _a[vdl_prefix_1.vdlPrefix('accordion-panel--collapsed')] = !this.isExpanded(), _a);
    return react_1.default.createElement("div", __assign({}, customProps, {
      className: classnames_1.classNames(this.props.className, panelClasses),
      id: this.props.collapsible ? undefined : this.props.id
    }), this.renderHeading(headerRole), this.props.collapsible ? this.renderCollapsibleBody(panelRole) : this.renderBody(), this.renderFooter());
  };
  Panel.propTypes = {
    collapsible: prop_types_1.default.bool,
    onSelect: prop_types_1.default.func,
    header: prop_types_1.default.node,
    id: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
    footer: prop_types_1.default.node,
    defaultExpanded: prop_types_1.default.bool,
    expanded: prop_types_1.default.bool,
    eventKey: prop_types_1.default.any,
    headerRole: prop_types_1.default.string,
    panelRole: prop_types_1.default.string,
    onEnter: collapse_1.Collapse.propTypes.onEnter,
    onEntering: collapse_1.Collapse.propTypes.onEntering,
    onEntered: collapse_1.Collapse.propTypes.onEntered,
    onExit: collapse_1.Collapse.propTypes.onExit,
    onExiting: collapse_1.Collapse.propTypes.onExiting,
    onExited: collapse_1.Collapse.propTypes.onExited,
    className: prop_types_1.default.string,
    children: prop_types_1.default.node
  };
  Panel.defaultProps = {
    defaultExpanded: false
  };
  return Panel;
}(react_1.default.Component);
exports.Panel = Panel;